import { EventType } from '@/types/projects.types';
import { Get } from '../helpers';

type TProjectCategoriesOptions = {
  includeGlobalProjectCategories?: boolean;
  templatesOnly?: boolean;
  eventType?: EventType;
};

export const FetchAllProjectCategoriesForChannel = async (
  channel: number,
  options?: TProjectCategoriesOptions
): Promise<{ categories: string[] }> => {
  const params = new URLSearchParams();
  if (options?.includeGlobalProjectCategories) {
    params.append('includeGlobalProjectCategories', 'true');
  }
  if (options?.templatesOnly) {
    params.append('templatesOnly', 'true');
  }
  if (options?.eventType) {
    params.append('eventType', options.eventType);
  }
  return Get({
    path: `/v3/admin/events/all-project-categories/${channel}?${params.toString()}`,
  });
};
